import DurationActions from "../../prat_actions/gt/durationAction";

const DurationReducer = (state = { isDurationLoading: false }, action) => {

    switch (action.type) {
    case DurationActions.START_WEEK_REQUEST:
      return {
        ...state,
        isDurationLoading: true
      };
    case DurationActions.START_WEEK_SUCCESS:
      return {
        ...state,
        isDurationLoading: false,
        startWeek: action.data
      };
    case DurationActions.START_WEEK_FAILED:
      return {
        ...state,
        errorMessage: action,
        isDurationLoading: false
      };

    //   end week 
   case DurationActions.END_WEEK_REQUEST:
    return {
        ...state,
        isDurationLoading: true
      };
    case DurationActions.END_WEEK_SUCCESS:
      return {
        ...state,
        isDurationLoading: false,
        endWeek: action.data
      };
    case DurationActions.END_WEEK_FAILED:
      return {
        ...state,
        errorMessage: {},
        isDurationLoading: false
      };
    default:
      return {
        ...state
      };
  }
};

export default DurationReducer;
